import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Query } from "system/query/Query";
import { QueryInfo } from "system/query/QueryInfo";
import QuerySegmentOptionsDialog from "components/queries/queryBuilder/dialogParts/QuerySegmentOptionsDialog";
import { SimpleFormLabel } from "components/dialogs/SimpleFormDialog";
import { QueryFieldSelector } from "components/queries/queryBuilder/dialogParts/QueryFieldSelector";
import { MenuItem, Select, TextField } from "@mui/material";
import { QuerySegment } from "system/query/QuerySegment";
import { QuerySpan } from "system/query/QuerySpan";

export interface QuerySpanBuilderDialogProps {
  isOpen: boolean;
  setDialogIsOpen: Function;
  parent?: QuerySegment | Query;
  querySpan: QuerySpan;
  queryInfo: QueryInfo;
  updateQuery: Function;
  originalQuery: Query;
}

export function QuerySpanBuilderDialog(props: QuerySpanBuilderDialogProps): JSX.Element {
  const {i18n} = useTranslation();

  const [fieldId, setFieldId] = useState<string>(props.querySpan.field || "");
  const [distance, setDistance] = useState<number | undefined>(props.querySpan.distance || 1);

  const [isOrdered, setIsOrdered] = useState<boolean>(props.querySpan.ordered || false);

  return (
    <QuerySegmentOptionsDialog
      isOpen={props.isOpen}
      parent={props.parent}
      querySegment={props.querySpan}
      updateQuery={props.updateQuery}
      originalQuery={props.originalQuery}

      onCancel={(event: any) => {
        event.stopPropagation();
        props.setDialogIsOpen(false)
      }}
      onConfirm={(event: any) => {
        event.stopPropagation();
        props.querySpan.distance = distance;
        props.querySpan.field = fieldId;
        if (isOrdered) {
          props.querySpan.ordered = isOrdered;
        } else {
          delete props.querySpan.ordered;
        }
        props.updateQuery(props.originalQuery);
        props.setDialogIsOpen(false)
      }}
      title={i18n.t("query-form.span-dialog-title")}
      >
      <SimpleFormLabel>{i18n.t("query-form.field-select")}</SimpleFormLabel>
      <QueryFieldSelector
        requireQuerySupported={true}
        fields={props.queryInfo.fields}
        allowedFieldTypes={["text"]}
        selectedFieldId={fieldId}
        setSelectedFieldId={setFieldId} />
      <SimpleFormLabel>{i18n.t("query-form.span-distance")}</SimpleFormLabel>
      <TextField
        autoComplete="off"
        type="number"
        value={distance}
        onChange={(event: any) => setDistance(event.target.value)} />
      <SimpleFormLabel>{i18n.t("query-form.span-ordering-label")}</SimpleFormLabel>
      <Select
        value={isOrdered ? "true" : "false"}
        onChange={(event: any) => setIsOrdered(event.target.value === "true")}>
        <MenuItem value={"false"}>{i18n.t("query-form.span-not-ordered")}</MenuItem>
        <MenuItem value={"true"}>{i18n.t("query-form.span-ordered")}</MenuItem>
      </Select>

   </QuerySegmentOptionsDialog>
  );
}